import type { Subscription } from '@localagent/sdk';

function formatPrice(cents: number): string {
  if (cents === 0) return 'Free';
  return `$${(cents / 100).toFixed(0)}/mo`;
}

function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
}

const statusColors: Record<string, string> = {
  active: 'bg-green-500/10 text-green-700 dark:text-green-400',
  past_due: 'bg-yellow-500/10 text-yellow-700 dark:text-yellow-400',
  canceled: 'bg-red-500/10 text-red-700 dark:text-red-400',
};

export function CurrentPlanCard({ subscription }: { subscription: Subscription }) {
  const statusClass = statusColors[subscription.status] ?? 'bg-muted text-muted-foreground';

  return (
    <div className="rounded-lg bg-card p-4 space-y-3">
      <div className="flex items-center justify-between">
        <div>
          <h3 className="text-sm font-medium text-muted-foreground">Current Plan</h3>
          <p className="text-lg font-semibold">{subscription.plan_display_name}</p>
        </div>
        <div className="text-right">
          <p className="text-lg font-semibold">{formatPrice(subscription.monthly_base_price_cents)}</p>
          <span className={`inline-block rounded px-2 py-0.5 text-xs font-medium ${statusClass}`}>
            {subscription.status}
          </span>
        </div>
      </div>
      <div className="flex gap-4 text-xs text-muted-foreground">
        <span>{subscription.included_credits.toLocaleString()} credits/month</span>
        <span>
          {formatDate(subscription.current_period_start)} — {formatDate(subscription.current_period_end)}
        </span>
      </div>
    </div>
  );
}
